import { useTranslation } from 'react-i18next'
import Icon from 'Components/Icon'
import { useNavigate } from 'react-router-dom'
import { deleteAllBasicData } from 'DataBase/BasicDataDB'
import { useServiceWorkerVersion } from 'Hooks/useServiceWorkerVersion'
import { clearApiStates } from 'Utils/resetApiStates'
import { refreshTranslations } from 'Utils/refreshTranslations'

interface IProps {
  drawerVisible: boolean
  setDrawerVisible: (visible: boolean) => void
}

export default function DrawerMenu(props: IProps) {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const version = useServiceWorkerVersion()

  const updateData = async () => {
    await deleteAllBasicData()
    await clearApiStates()
    await refreshTranslations()

    window.location.reload()
  }

  return (
    <div className="fixed inset-y-0 right-0 flex flex-col bg-white w-3/4 z-20 transition-transform translate-x-full group-[.show-asidemenu]:translate-x-0">
      <div className="flex p-6" onClick={() => props.setDrawerVisible(false)}>
        <Icon className="w-6 h-6" name="close" />
      </div>

      <ul className="grow overflow-auto px-6">
        <li>
          <span
            onClick={() => {
              navigate('/')
              props.setDrawerVisible(false)
            }}
            className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold"
          >
            <Icon className="w-6 h-6" name="home-2" />
            {t('HOME')}
          </span>
        </li>
        <li>
          <span
            onClick={() => {
              navigate('/Visits')
              props.setDrawerVisible(false)
            }}
            className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold"
          >
            <Icon className="w-6 h-6" name="clipboard-tick" />
            {t('VISITS')}
          </span>
        </li>
        <li>
          <span
            onClick={() => {
              navigate('/Account')
              props.setDrawerVisible(false)
            }}
            className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold"
          >
            <Icon className="w-6 h-6" name="profile" />
            {t('ACCOUNT')}
          </span>
        </li>
        <li>
          <a href="#" className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold">
            <Icon className="w-6 h-6" name="24-support" />
            پشتیبانی
          </a>
        </li>
        <li>
          <a href="#" className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold">
            <Icon className="w-6 h-6" name="document-text" />
            قوانین و مقررات
          </a>
        </li>
        <li>
          <a href="#" className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold">
            <Icon className="w-6 h-6" name="document-favorite" />
            درباره ما
          </a>
        </li>
        <li>
          <a
            href="/Files/USER MANUAL.pdf"
            target="_blank"
            className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold"
          >
            <Icon className="w-6 h-6" name="ic_info" />
            راهنمای کاربری
          </a>
        </li>
        <li>
          <span
            onClick={updateData}
            className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold"
          >
            <Icon className="w-6 h-6" name="rotate-left" />
            {t('UPDATE_DATA')}
          </span>
        </li>
      </ul>
      <div className="p-6" onClick={() => navigate('/SignOut')}>
        <div className="flex items-center gap-4 py-4 text-gray-800 text-sm font-semibold cursor-pointer">
          <Icon className="w-6 h-6" name="logout" />
          خروج از حساب
        </div>
      </div>

      <span className="px-6" style={{ fontSize: 12, margin: '5px' }}>
        تمامی حقوق مادی و معنوی این سامانه متعلق به شرکت{' '}
        <a href="https://ritonsolutions.ir/about/" target="_blank">
          ریتون
        </a>{' '}
        است
        <br />
        <div className="w-100 text-center">
          ورژن {<span style={{ color: 'red', direction: 'ltr' }}>{version}</span>}
        </div>
      </span>
    </div>
  )
}
